/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type DocumentStatus = typeof DocumentStatus[keyof typeof DocumentStatus];


export const DocumentStatus = {
  DRAFT: 'DRAFT',
  UPLOADED: 'UPLOADED',
  PROCESSING: 'PROCESSING',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
  PASSWORD_PROTECTED: 'PASSWORD_PROTECTED',
} as const;
